import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg contacting-7 font-medium text-black" }, "Days of the week workflow should trigger", -1)

import { watch } from "vue"
import { ClockIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { formatters } from "@/shared/utils/dateUtils"
import GgmsMultiSelect from "@/components/GgmsMultiSelect.vue"
import GgmsCalendar from "@/components/GgmsCalendar.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'WeekDaysScheduleComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

const daysOptions = [
    { label: "Monday", value: "monday" },
    { label: "Tuesday", value: "tuesday" },
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
]

watch(
    () => workflowStore.modelValue.time,
    () => {
        //convert time into ISO date
        if (workflowStore.modelValue.time) {
            workflowStore.modelValue.dateTime = formatters.dateTimeConverter(workflowStore.modelValue.time)
        }
    }
)

watch(
    () => [workflowStore.modelValue.days, workflowStore.modelValue.time],
    () => {
        workflowStore.areButtonDisabled = !workflowStore.modelValue.days.length || !workflowStore.modelValue.time
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GgmsMultiSelect, {
      modelValue: _unref(workflowStore).modelValue.days,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.days) = $event)),
      options: daysOptions,
      "option-label": "label",
      "option-value": "value",
      placeholder: "Choose day or days",
      classes: "w-full"
    }, null, 8, ["modelValue"]),
    _createVNode(GgmsCalendar, {
      modelValue: _unref(workflowStore).modelValue.time,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.time) = $event)),
      position: "below",
      label: "Select time",
      showTime: true,
      showDate: false,
      iconStart: _unref(ClockIcon)
    }, null, 8, ["modelValue", "iconStart"])
  ]))
}
}

})